// Multilingual translations for Faustitur Tourism Taxi
export const LANGS = [
  { code: "pt", label: "PT" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];

const SHARED_ITEMS = [
  { id: "zoomarine", price: "€55" },
  { id: "slidesplash", price: "€30" },
  { id: "lagos", price: "€30" },
  { id: "albufeira", price: "€55" },
  { id: "faro", price: "€90" },
  { id: "lisboa", price: "€345" },
  { id: "sevilha", price: "€305" },
  { id: "porto", price: "€770" },
  { id: "beja", price: "€190" },
];

const localiseItems = (labels) =>
  SHARED_ITEMS.map((it) => ({ ...it, ...labels[it.id] }));

export const translations = {
  pt: {
    nav: { services: "Serviços", tours: "Tours", booking: "Reservar", contact: "Contacto", about: "Sobre" },
    hero: {
      eyebrow: "Táxi licenciado · Município de Portimão",
      title: "O Algarve com conforto, confiança e elegância.",
      subtitle:
        "Faustitur — Táxi de Turismo. Viatura Seat Alhambra preta, 7 lugares (até 6 passageiros). Transferes para aeroportos, parques aquáticos e tours privados pelo Algarve.",
      callBtn: "Ligar agora",
      whatsappBtn: "WhatsApp",
      bookBtn: "Pedir reserva",
      badges: ["Licenciado", "24/7", "Até 6 passageiros"],
    },
    trust: {
      title: "Transporte público de confiança",
      body:
        "A Faustitur opera com licença municipal em Portimão, oferecendo um serviço de táxi profissional e personalizado para residentes e turistas no Algarve. Viagens em Seat Alhambra preta, 7 lugares (até 6 passageiros) — espaço, conforto e segurança em cada quilómetro.",
      stats: [
        { value: "6", label: "Passageiros · Seat Alhambra" },
        { value: "24/7", label: "Disponibilidade" },
        { value: "100%", label: "Licenciado · Portimão" },
      ],
    },
    services: {
      eyebrow: "Tarifas Especiais",
      title: "Destinos preferidos",
      subtitle:
        "Preços indicativos partindo de Portimão. Solicite orçamento personalizado para outros pontos.",
      airportsLabel: "Transferes para Aeroporto",
      airportsHint: "Reserva com 24 h de antecedência · viagem direta · até 6 passageiros",
      leisureLabel: "Parques & Destinos turísticos",
      reserveCta: "Reservar",
      cta: "Pedir orçamento",
      quoteLabel: "Sob consulta",
      fromLabel: "desde",
      items: localiseItems({
        zoomarine: { name: "Zoomarine", desc: "Parque marinho, Albufeira" },
        slidesplash: { name: "Slide & Splash", desc: "Parque aquático, Lagoa" },
        lagos: { name: "Lagos", desc: "Praias e centro histórico" },
        albufeira: { name: "Albufeira", desc: "Centro e Marina" },
        faro: { name: "Aeroporto de Faro", desc: "FAO · Algarve" },
        lisboa: { name: "Aeroporto de Lisboa", desc: "LIS · Capital" },
        sevilha: { name: "Aeroporto de Sevilha", desc: "SVQ · Espanha" },
        porto: { name: "Aeroporto do Porto", desc: "OPO · Norte" },
        beja: { name: "Aeroporto de Beja", desc: "BYJ · Alentejo" },
      }),
    },
    tours: {
      eyebrow: "Experiências Privadas",
      title: "Tours pelo Algarve",
      subtitle:
        "Descubra a costa algarvia com um motorista local. Roteiros à medida, paragens fotográficas e recomendações autênticas.",
      priceHint: "Sob consulta · desde €30/hora",
      cards: [
        { title: "Costa Vicentina", desc: "Sagres, Cabo de S. Vicente e praias selvagens do oeste.", duration: "1 dia" },
        { title: "Benagil & Grutas", desc: "Praia da Marinha, Algar Seco e as grutas mais icónicas.", duration: "1/2 dia" },
        { title: "Serra & Vilas Brancas", desc: "Monchique, Caldas e aldeias tradicionais do interior.", duration: "1 dia" },
        { title: "Tavira & Ria Formosa", desc: "Algarve oriental, ilhas e tradições do sotavento.", duration: "1 dia" },
      ],
      cta: "Personalizar tour",
    },
    reviews: {
      eyebrow: "Avaliações",
      title: "O que dizem os nossos clientes",
      ratingLabel: "Avaliação Google",
      reviewsLabel: "Ver avaliações no Google",
      summary:
        "Centenas de turistas e residentes confiam na Faustitur para os seus transferes e tours no Algarve.",
    },
    booking: {
      eyebrow: "Reserva online",
      title: "Peça a sua viagem",
      subtitle:
        "Preencha os detalhes — confirmamos por WhatsApp ou telefone em poucos minutos.",
      fields: {
        name: "Nome completo",
        phone: "Telefone / WhatsApp",
        email: "Email (opcional)",
        pickup: "Origem (morada / hotel)",
        destination: "Destino",
        date: "Data",
        time: "Hora",
        passengers: "Passageiros",
        notes: "Notas (bagagem, cadeira de criança...)",
      },
      submit: "Pedir reserva",
      sending: "A enviar...",
      success: "Reserva recebida! Entraremos em contacto em breve.",
      error: "Não foi possível enviar. Tente por telefone ou WhatsApp.",
      requiredErr: "Preencha os campos obrigatórios.",
    },
    contact: {
      eyebrow: "Contactos",
      title: "Fale connosco",
      subtitle: "Disponível 24 horas para o seu transfer ou tour.",
      phone: "Telefone & WhatsApp",
      area: "Base de operação",
      areaValue: "Portimão · Algarve · Portugal",
      hours: "Horário",
      hoursValue: "24 horas / 7 dias",
    },
    footer: {
      tagline: "Táxi de Turismo licenciado · Portimão · Seat Alhambra · até 6 passageiros",
      rights: "Todos os direitos reservados.",
      links: { services: "Serviços", tours: "Tours", booking: "Reservar", contact: "Contacto" },
      admin: "Admin",
    },
  },

  en: {
    nav: { services: "Services", tours: "Tours", booking: "Book", contact: "Contact", about: "About" },
    hero: {
      eyebrow: "Licensed Taxi · Municipality of Portimão",
      title: "The Algarve, in comfort and trusted elegance.",
      subtitle:
        "Faustitur — Tourism Taxi. Black Seat Alhambra, 7-seater (up to 6 passengers). Airport transfers, water park rides and private tours across the Algarve.",
      callBtn: "Call now",
      whatsappBtn: "WhatsApp",
      bookBtn: "Request booking",
      badges: ["Licensed", "24/7", "Up to 6 passengers"],
    },
    trust: {
      title: "Trusted public transport",
      body:
        "Faustitur operates under a municipal license in Portimão, offering a professional, personal taxi service for residents and visitors across the Algarve. Travel in a black Seat Alhambra, 7-seater (up to 6 passengers) — space, comfort and safety on every kilometre.",
      stats: [
        { value: "6", label: "Passengers · Seat Alhambra" },
        { value: "24/7", label: "Availability" },
        { value: "100%", label: "Licensed · Portimão" },
      ],
    },
    services: {
      eyebrow: "Special Fares",
      title: "Favourite destinations",
      subtitle:
        "Indicative prices from Portimão. Request a personalised quote for other locations.",
      airportsLabel: "Airport Transfers",
      airportsHint: "Book 24 h ahead · direct ride · up to 6 passengers",
      leisureLabel: "Parks & Leisure Destinations",
      reserveCta: "Book",
      cta: "Get a quote",
      quoteLabel: "On request",
      fromLabel: "from",
      items: localiseItems({
        zoomarine: { name: "Zoomarine", desc: "Marine park, Albufeira" },
        slidesplash: { name: "Slide & Splash", desc: "Water park, Lagoa" },
        lagos: { name: "Lagos", desc: "Beaches & old town" },
        albufeira: { name: "Albufeira", desc: "Centre & Marina" },
        faro: { name: "Faro Airport", desc: "FAO · Algarve" },
        lisboa: { name: "Lisbon Airport", desc: "LIS · Capital" },
        sevilha: { name: "Seville Airport", desc: "SVQ · Spain" },
        porto: { name: "Porto Airport", desc: "OPO · North" },
        beja: { name: "Beja Airport", desc: "BYJ · Alentejo" },
      }),
    },
    tours: {
      eyebrow: "Private Experiences",
      title: "Algarve Tours",
      subtitle:
        "Explore the Algarve coast with a local driver. Tailored routes, photo stops and authentic tips.",
      priceHint: "On request · from €30/hour",
      cards: [
        { title: "Costa Vicentina", desc: "Sagres, Cape St. Vincent and the wild west coast.", duration: "Full day" },
        { title: "Benagil & Caves", desc: "Marinha Beach, Algar Seco and the iconic sea caves.", duration: "Half day" },
        { title: "Mountains & White Villages", desc: "Monchique, Caldas and traditional inland villages.", duration: "Full day" },
        { title: "Tavira & Ria Formosa", desc: "Eastern Algarve, islands and old traditions.", duration: "Full day" },
      ],
      cta: "Customise tour",
    },
    reviews: {
      eyebrow: "Reviews",
      title: "What our clients say",
      ratingLabel: "Google Rating",
      reviewsLabel: "Read reviews on Google",
      summary:
        "Hundreds of tourists and locals trust Faustitur for their transfers and tours in the Algarve.",
    },
    booking: {
      eyebrow: "Online booking",
      title: "Request your ride",
      subtitle: "Fill in the details — we confirm by WhatsApp or phone within minutes.",
      fields: {
        name: "Full name",
        phone: "Phone / WhatsApp",
        email: "Email (optional)",
        pickup: "Pickup (address / hotel)",
        destination: "Destination",
        date: "Date",
        time: "Time",
        passengers: "Passengers",
        notes: "Notes (luggage, child seat...)",
      },
      submit: "Request booking",
      sending: "Sending...",
      success: "Booking received! We will contact you shortly.",
      error: "Could not send. Please try phone or WhatsApp.",
      requiredErr: "Please complete the required fields.",
    },
    contact: {
      eyebrow: "Contacts",
      title: "Get in touch",
      subtitle: "Available 24 hours for your transfer or tour.",
      phone: "Phone & WhatsApp",
      area: "Operating base",
      areaValue: "Portimão · Algarve · Portugal",
      hours: "Hours",
      hoursValue: "24 hours / 7 days",
    },
    footer: {
      tagline: "Licensed Tourism Taxi · Portimão · Seat Alhambra · up to 6 passengers",
      rights: "All rights reserved.",
      links: { services: "Services", tours: "Tours", booking: "Book", contact: "Contact" },
      admin: "Admin",
    },
  },

  es: {
    nav: { services: "Servicios", tours: "Tours", booking: "Reservar", contact: "Contacto", about: "Nosotros" },
    hero: {
      eyebrow: "Taxi licenciado · Municipio de Portimão",
      title: "El Algarve con confort, confianza y elegancia.",
      subtitle:
        "Faustitur — Taxi de Turismo. Seat Alhambra negro, 7 plazas (hasta 6 pasajeros). Traslados al aeropuerto, parques acuáticos y tours privados por el Algarve.",
      callBtn: "Llamar ahora",
      whatsappBtn: "WhatsApp",
      bookBtn: "Solicitar reserva",
      badges: ["Licenciado", "24/7", "Hasta 6 pasajeros"],
    },
    trust: {
      title: "Transporte público de confianza",
      body:
        "Faustitur opera con licencia municipal en Portimão, ofreciendo un servicio de taxi profesional y personalizado para residentes y turistas en el Algarve. Viajes en Seat Alhambra negro, 7 plazas (hasta 6 pasajeros) — espacio, confort y seguridad en cada kilómetro.",
      stats: [
        { value: "6", label: "Pasajeros · Seat Alhambra" },
        { value: "24/7", label: "Disponibilidad" },
        { value: "100%", label: "Licenciado · Portimão" },
      ],
    },
    services: {
      eyebrow: "Tarifas Especiales",
      title: "Destinos favoritos",
      subtitle:
        "Precios indicativos desde Portimão. Solicite presupuesto personalizado para otros destinos.",
      airportsLabel: "Traslados al Aeropuerto",
      airportsHint: "Reserva con 24 h de antelación · viaje directo · hasta 6 pasajeros",
      leisureLabel: "Parques y Destinos turísticos",
      reserveCta: "Reservar",
      cta: "Pedir presupuesto",
      quoteLabel: "A consultar",
      fromLabel: "desde",
      items: localiseItems({
        zoomarine: { name: "Zoomarine", desc: "Parque marino, Albufeira" },
        slidesplash: { name: "Slide & Splash", desc: "Parque acuático, Lagoa" },
        lagos: { name: "Lagos", desc: "Playas y casco histórico" },
        albufeira: { name: "Albufeira", desc: "Centro y Marina" },
        faro: { name: "Aeropuerto de Faro", desc: "FAO · Algarve" },
        lisboa: { name: "Aeropuerto de Lisboa", desc: "LIS · Capital" },
        sevilha: { name: "Aeropuerto de Sevilla", desc: "SVQ · España" },
        porto: { name: "Aeropuerto de Oporto", desc: "OPO · Norte" },
        beja: { name: "Aeropuerto de Beja", desc: "BYJ · Alentejo" },
      }),
    },
    tours: {
      eyebrow: "Experiencias Privadas",
      title: "Tours por el Algarve",
      subtitle:
        "Descubra la costa algarviana con un conductor local. Rutas a medida, paradas fotográficas y consejos auténticos.",
      priceHint: "A consultar · desde €30/hora",
      cards: [
        { title: "Costa Vicentina", desc: "Sagres, Cabo de San Vicente y playas salvajes.", duration: "1 día" },
        { title: "Benagil y Cuevas", desc: "Playa de la Marinha, Algar Seco y las cuevas marinas.", duration: "1/2 día" },
        { title: "Sierra y Pueblos Blancos", desc: "Monchique, Caldas y pueblos tradicionales.", duration: "1 día" },
        { title: "Tavira y Ría Formosa", desc: "Algarve oriental, islas y tradiciones.", duration: "1 día" },
      ],
      cta: "Personalizar tour",
    },
    reviews: {
      eyebrow: "Valoraciones",
      title: "Lo que dicen nuestros clientes",
      ratingLabel: "Valoración Google",
      reviewsLabel: "Ver valoraciones en Google",
      summary:
        "Cientos de turistas y residentes confían en Faustitur para sus traslados y tours en el Algarve.",
    },
    booking: {
      eyebrow: "Reserva online",
      title: "Pida su viaje",
      subtitle: "Rellene los detalles — confirmamos por WhatsApp o teléfono en minutos.",
      fields: {
        name: "Nombre completo",
        phone: "Teléfono / WhatsApp",
        email: "Email (opcional)",
        pickup: "Origen (dirección / hotel)",
        destination: "Destino",
        date: "Fecha",
        time: "Hora",
        passengers: "Pasajeros",
        notes: "Notas (equipaje, silla niño...)",
      },
      submit: "Solicitar reserva",
      sending: "Enviando...",
      success: "¡Reserva recibida! Contactaremos en breve.",
      error: "No se pudo enviar. Pruebe por teléfono o WhatsApp.",
      requiredErr: "Complete los campos obligatorios.",
    },
    contact: {
      eyebrow: "Contactos",
      title: "Hable con nosotros",
      subtitle: "Disponible 24 horas para su traslado o tour.",
      phone: "Teléfono & WhatsApp",
      area: "Base de operación",
      areaValue: "Portimão · Algarve · Portugal",
      hours: "Horario",
      hoursValue: "24 horas / 7 días",
    },
    footer: {
      tagline: "Taxi de Turismo licenciado · Portimão · Seat Alhambra · hasta 6 pasajeros",
      rights: "Todos los derechos reservados.",
      links: { services: "Servicios", tours: "Tours", booking: "Reservar", contact: "Contacto" },
      admin: "Admin",
    },
  },
};

export const COMPANY = {
  name: "Faustitur Tourism Taxi",
  phone: "+351912928790",
  phoneDisplay: "+351 912 928 790",
  whatsappLink: "https://wa.me/351912928790",
  telLink: "tel:+351912928790",
  logo: "https://customer-assets.emergentagent.com/job_4442d7a3-fb37-4f59-ba56-82f59fc70f4a/artifacts/xa9yd5ps_logo_001.jpg",
  base: "Portimão, Algarve, Portugal",
  email: "faustitur@gmail.com",
  vehicle: "Seat Alhambra · 7 lugares",
  googleReviewsUrl:
    "https://share.google/fE6IkQD90zjPaXv50",
  googleRating: 5.0,
  googleReviewsCount: "100+",
  instagramUrl: "https://www.instagram.com/faustitur/",
  facebookUrl: "https://www.facebook.com/faustiturtaxi/?locale=pt_PT",
};
